import React from "react";
import { connect } from "react-redux";
import { findSubLineItem } from "shared/selectors/unit";
import { withRouter } from "../../helpers/withRouter";

import CatalogPage from "./CatalogPage";
import ProductOptions from "./ProductOptions";

import "./productOptions.scss";
import { SubLineItemShape } from "../configurator/roomBook.shape";

function SubLineItemPage({ subLineItem }) {
  return (
    <CatalogPage data-component="subLineItemPage">
      <ProductOptions subLineItem={subLineItem} />
    </CatalogPage>
  );
}

SubLineItemPage.propTypes = {
  subLineItem: SubLineItemShape.isRequired
};

const mapStateToProps = (state, props) => {
  const { subLineItemId } = props.params;
  const subLineItem = findSubLineItem(state)(subLineItemId);
  return {
    subLineItem
  };
};

export default withRouter(connect(mapStateToProps)(SubLineItemPage));
